"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBubbleStyle;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* eslint no-magic-numbers: ["error", { "ignore": [0, 1, 2] }] */


function isPositive(value) {
  return 1 / value >= 0;
}

function createBubbleStyle(_ref) {
  var bubbleBackground = _ref.bubbleBackground,
      bubbleBorderColor = _ref.bubbleBorderColor,
      bubbleBorderRadius = _ref.bubbleBorderRadius,
      bubbleBorderStyle = _ref.bubbleBorderStyle,
      bubbleBorderWidth = _ref.bubbleBorderWidth,
      bubbleFromUserBackground = _ref.bubbleFromUserBackground,
      bubbleFromUserBorderColor = _ref.bubbleFromUserBorderColor,
      bubbleFromUserBorderRadius = _ref.bubbleFromUserBorderRadius,
      bubbleFromUserBorderStyle = _ref.bubbleFromUserBorderStyle,
      bubbleFromUserBorderWidth = _ref.bubbleFromUserBorderWidth,
      bubbleFromUserNubOffset = _ref.bubbleFromUserNubOffset,
      bubbleFromUserNubSize = _ref.bubbleFromUserNubSize,
      bubbleFromUserTextColor = _ref.bubbleFromUserTextColor,
      bubbleMinHeight = _ref.bubbleMinHeight,
      bubbleNubOffset = _ref.bubbleNubOffset,
      bubbleNubSize = _ref.bubbleNubSize,
      bubbleTextColor = _ref.bubbleTextColor,
      messageActivityWordBreak = _ref.messageActivityWordBreak,
      paddingRegular = _ref.paddingRegular;
  var botNubUpSideDown = !isPositive(bubbleNubOffset);
  var userNubUpSideDown = !isPositive(bubbleFromUserNubOffset);
  var botNubCornerRadius = Math.min(bubbleBorderRadius, Math.abs(bubbleNubOffset));
  var userNubCornerRadius = Math.min(bubbleFromUserBorderRadius, Math.abs(bubbleFromUserNubOffset));
  return {
    '& > .webchat__bubble__content': {
      wordBreak: messageActivityWordBreak
    },
    '& > .webchat__bubble__nub': {
      overflow: 'hidden',
      // This style is for IE11 because it don't respect SVG viewport
      position: 'absolute'
    },
    '&:not(.from-user)': {
      '&.webchat__bubble_has_nub': {
        '& > .webchat__bubble__content': bubbleNubSize ? {
          marginLeft: paddingRegular
        } : {}
      },
      '& > .webchat__bubble__content': {
        background: bubbleBackground,
        borderColor: bubbleBorderColor,
        borderRadius: bubbleBorderRadius,
        borderStyle: bubbleBorderStyle,
        borderWidth: bubbleBorderWidth,
        color: bubbleTextColor,
        minHeight: bubbleMinHeight - bubbleBorderWidth * 2
      },
      '&.webchat__bubble_has_nub > .webchat__bubble__content': _objectSpread({}, bubbleNubSize && botNubUpSideDown ? {
        borderBottomLeftRadius: botNubCornerRadius
      } : {}, {}, bubbleNubSize && !botNubUpSideDown ? {
        borderTopLeftRadius: botNubCornerRadius
      } : {}),
      '& > .webchat__bubble__nub': {
        bottom: isPositive(bubbleNubOffset) ? undefined : -bubbleNubOffset,
        height: bubbleNubSize,
        left: bubbleBorderWidth - bubbleNubSize + paddingRegular,
        top: isPositive(bubbleNubOffset) ? bubbleNubOffset : undefined,
        width: bubbleNubSize,
        '& > g > path': {
          fill: bubbleBackground,
          stroke: bubbleBorderColor,
          strokeWidth: bubbleBorderWidth
        }
      }
    },
    '&.from-user': {
      '&.webchat__bubble_has_nub': {
        '& > .webchat__bubble__content': bubbleNubSize ? {
          marginRight: paddingRegular
        } : {}
      },
      '& > .webchat__bubble__content': {
        background: bubbleFromUserBackground,
        borderColor: bubbleFromUserBorderColor,
        borderRadius: bubbleFromUserBorderRadius,
        borderStyle: bubbleFromUserBorderStyle,
        borderWidth: bubbleFromUserBorderWidth,
        color: bubbleFromUserTextColor,
        minHeight: bubbleMinHeight - bubbleFromUserBorderWidth * 2
      },
      '&.webchat__bubble_has_nub > .webchat__bubble__content': _objectSpread({}, bubbleFromUserNubSize && userNubUpSideDown ? {
        borderBottomRightRadius: userNubCornerRadius
      } : {}, {}, bubbleFromUserNubSize && !userNubUpSideDown ? {
        borderTopRightRadius: userNubCornerRadius
      } : {}),
      '& > .webchat__bubble__nub': {
        height: bubbleFromUserNubSize,
        right: bubbleFromUserBorderWidth - bubbleFromUserNubSize + paddingRegular,
        bottom: isPositive(bubbleFromUserNubOffset) ? undefined : -bubbleFromUserNubOffset,
        top: isPositive(bubbleFromUserNubOffset) ? bubbleFromUserNubOffset : undefined,
        width: bubbleFromUserNubSize,
        '& > g > path': {
          fill: bubbleFromUserBackground,
          stroke: bubbleFromUserBorderColor,
          strokeWidth: bubbleFromUserBorderWidth
        }
      }
    }
  };
}